// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.js-float-label-wrapper {
  position: relative;
  width: 90%;
}

.js-float-label-wrapper label {
  position: absolute;
  top: 1em;
  left: 1em;
  opacity: 0;
}

.js-float-label-wrapper.focused label, .js-float-label-wrapper.populated label {
  opacity: 1;
  color: #999;
  font-size: 0.75em;
  font-weight: 500;
}

.js-float-label-wrapper.focused input, .js-float-label-wrapper.focused textarea, .js-float-label-wrapper.populated input, .js-float-label-wrapper.populated textarea {
  padding-top: 2em;
}

.js-float-label-wrapper input, .js-float-label-wrapper label, .js-float-label-wrapper textarea {
  -webkit-transition: 0.2s ease-in-out;
  -moz-transition: 0.2s ease-in-out;
  -o-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
  color: #666;
}`, "",{"version":3,"sources":["webpack://./ezlibrary/welcome/css/float-label.css"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,UAAA;AACJ;;AAEA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;AACJ;;AAEA;EACI,UAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,oCAAA;EACA,iCAAA;EACA,+BAAA;EACA,4BAAA;EACA,WAAA;AACJ","sourcesContent":[".js-float-label-wrapper {\r\n    position: relative;\r\n    width: 90%\r\n}\r\n\r\n.js-float-label-wrapper label {\r\n    position: absolute;\r\n    top: 1em;\r\n    left: 1em;\r\n    opacity: 0\r\n}\r\n\r\n.js-float-label-wrapper.focused label, .js-float-label-wrapper.populated label {\r\n    opacity: 1;\r\n    color: #999;\r\n    font-size: .75em;\r\n    font-weight: 500\r\n}\r\n\r\n.js-float-label-wrapper.focused input, .js-float-label-wrapper.focused textarea, .js-float-label-wrapper.populated input, .js-float-label-wrapper.populated textarea {\r\n    padding-top: 2em\r\n}\r\n\r\n.js-float-label-wrapper input, .js-float-label-wrapper label, .js-float-label-wrapper textarea {\r\n    -webkit-transition: .2s ease-in-out;\r\n    -moz-transition: .2s ease-in-out;\r\n    -o-transition: .2s ease-in-out;\r\n    transition: .2s ease-in-out;\r\n    color: #666\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
